import React from "react";
import { Grid, Paper, Divider } from "@mui/material";
import DEDateField from "../../../../components/forms/DEDateField";
import { useGetOfficesQuery } from "../../../../features/offices/officesApiSlice";
import { useGetUsersCleanQuery } from "../../../../features/users/usersApiSlice";
import SelectUsersAreasOffices from "../../../../components/forms/Forms/SelectUsersAreasOffices";

function ReadingConfirmationForm({ fileData, control }) {
  const { data: offices } = useGetOfficesQuery();
  const { data: users = [] } = useGetUsersCleanQuery();

  return (
    <Paper elevation={0}>
      <Divider sx={{ marginBottom: 2 }} />

      <Grid container spacing={2}>
        {/* Lesebestätigungsliste */}

        <Grid item xs={12} md={8}>
          {offices && users && (
            <SelectUsersAreasOffices
              control={control}
              offices={offices}
              users={users}
            />
          )}
        </Grid>
        <Grid item sx={{ mt: { xs: 0, md: 15 } }} xs={12} md={4}>
          <DEDateField
            control={control}
            required={true}
            name="readingDueDate"
            label="Frist Lesebestätigung"
            errorMsg="Bitte ein Datum auswählen."
          />
        </Grid>
      </Grid>

      <Divider sx={{ marginY: 2 }} />
    </Paper>
  );
}

export default ReadingConfirmationForm;
